import script from "./PaywallPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./PaywallPlaceholder.vue?vue&type=style&index=0&id=2d546cc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d546cc5"]])

export default __exports__